import { render, staticRenderFns } from "./SectionContent.vue?vue&type=template&id=fa44ad58&"
import script from "./SectionContent.vue?vue&type=script&lang=js&"
export * from "./SectionContent.vue?vue&type=script&lang=js&"
import style0 from "./SectionContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports